var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import posthog from 'posthog-js';
var PostHogSessionRecorder = /** @class */ (function () {
    function PostHogSessionRecorder(inDev, apiKey, captureException, apiHost) {
        if (apiHost === void 0) { apiHost = 'https://eu.i.posthog.com'; }
        var _this = this;
        this.recording = false;
        this.recordingExpiresAt = null;
        this.stopTimer = null;
        this.inDev = inDev;
        this.captureException = captureException;
        posthog.init(apiKey, {
            api_host: apiHost,
            autocapture: false,
            rageclick: false,
            capture_pageview: false,
            capture_pageleave: false,
            capture_dead_clicks: false,
            capture_heatmaps: false,
            capture_performance: false,
            capture_exceptions: false,
            disable_surveys: true,
            disable_web_experiments: true,
            advanced_disable_feature_flags: true,
            advanced_disable_toolbar_metrics: true,
            disable_session_recording: true,
            session_recording: {
                maskAllInputs: false,
                maskInputOptions: {
                    password: true,
                },
            },
            before_send: function (event) { return (event === null || event === void 0 ? void 0 : event.event) === '$snapshot' ? event : null; },
        });
        posthog.onSessionId(function (sessionId) {
            _this.saveSessionCookie(sessionId);
        });
        // Touch the session through PostHog's public API so inactivity rotation is applied.
        // The before_send filter above prevents this synthetic event from being delivered.
        posthog.capture('invbg.session_activity');
        this.refreshSessionCookie();
        window.addEventListener(PostHogSessionRecorder.RECORDING_STATE_CHANGED_EVENT, function () {
            _this.refreshRecordingState();
        });
        this.refreshRecordingState();
    }
    PostHogSessionRecorder.prototype.refreshRecordingState = function () {
        try {
            this.applyRecordingCookie();
        }
        catch (error) {
            this.captureException(error);
        }
    };
    PostHogSessionRecorder.prototype.applyRecordingCookie = function () {
        var expiresAt = this.readRecordingExpiration();
        if (expiresAt === null || expiresAt <= Date.now()) {
            this.recordingExpiresAt = null;
            this.stopRecording();
            return;
        }
        if (this.recording && this.recordingExpiresAt === expiresAt) {
            return;
        }
        this.recordingExpiresAt = expiresAt;
        this.startRecording();
        this.scheduleStop(expiresAt);
    };
    PostHogSessionRecorder.prototype.startRecording = function () {
        if (this.recording) {
            return;
        }
        posthog.startSessionRecording(true);
        this.refreshSessionCookie();
        this.recording = true;
        this.log('Session recording started');
    };
    PostHogSessionRecorder.prototype.stopRecording = function () {
        this.cancelStopTimer();
        if (!this.recording) {
            return;
        }
        posthog.stopSessionRecording();
        this.refreshSessionCookie();
        this.recording = false;
        this.log('Session recording stopped');
    };
    PostHogSessionRecorder.prototype.scheduleStop = function (expiresAt) {
        var _this = this;
        this.cancelStopTimer();
        this.stopTimer = window.setTimeout(function () {
            _this.refreshRecordingState();
        }, Math.max(0, expiresAt - Date.now()));
    };
    PostHogSessionRecorder.prototype.cancelStopTimer = function () {
        if (this.stopTimer === null) {
            return;
        }
        window.clearTimeout(this.stopTimer);
        this.stopTimer = null;
    };
    PostHogSessionRecorder.prototype.readRecordingExpiration = function () {
        var prefix = "".concat(PostHogSessionRecorder.RECORDING_COOKIE, "=");
        var cookie = document.cookie
            .split('; ')
            .find(function (value) { return value.startsWith(prefix); });
        if (cookie === undefined) {
            return null;
        }
        var expiresAt = Number(decodeURIComponent(cookie.slice(prefix.length)));
        if (!Number.isSafeInteger(expiresAt) || expiresAt < 1) {
            return null;
        }
        return expiresAt * 1000;
    };
    PostHogSessionRecorder.prototype.refreshSessionCookie = function () {
        try {
            var sessionId = posthog.get_session_id();
            if (!sessionId) {
                return;
            }
            this.saveSessionCookie(sessionId);
        }
        catch (error) {
            this.captureException(error);
        }
    };
    PostHogSessionRecorder.prototype.saveSessionCookie = function (sessionId) {
        var _a;
        var domain = (_a = document
            .querySelector('meta[name="posthog-cookie-domain"]')) === null || _a === void 0 ? void 0 : _a.content;
        var attributes = [
            "".concat(PostHogSessionRecorder.SESSION_COOKIE, "=").concat(encodeURIComponent(sessionId)),
            'Path=/',
            "Max-Age=".concat(PostHogSessionRecorder.SESSION_COOKIE_MAX_AGE_SECONDS),
            'SameSite=Lax',
        ];
        if (domain) {
            attributes.push("Domain=".concat(domain));
        }
        if (window.location.protocol === 'https:') {
            attributes.push('Secure');
        }
        document.cookie = attributes.join('; ');
    };
    PostHogSessionRecorder.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.inDev) {
            console.log.apply(console, __spreadArray(['[PostHogSessionRecorder]'], args, false));
        }
    };
    PostHogSessionRecorder.RECORDING_COOKIE = 'posthog_recording_until';
    PostHogSessionRecorder.RECORDING_STATE_CHANGED_EVENT = 'product-analytics-recording-state-changed';
    PostHogSessionRecorder.SESSION_COOKIE = 'posthog_session_id';
    PostHogSessionRecorder.SESSION_COOKIE_MAX_AGE_SECONDS = 86400;
    return PostHogSessionRecorder;
}());
export default PostHogSessionRecorder;
export var trackSeyel = function (module, event, properties) {
    window.logSeyel(module, event, properties);
};
